.icon {
	vertical-align: middle;
}
